import { render, staticRenderFns } from "./VideoInput.vue?vue&type=template&id=623e8e55&scoped=true"
import script from "./VideoInput.vue?vue&type=script&lang=ts"
export * from "./VideoInput.vue?vue&type=script&lang=ts"
import style0 from "./VideoInput.vue?vue&type=style&index=0&id=623e8e55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e8e55",
  null
  
)

export default component.exports